<template>
  <div>
    <el-dialog title="预约时间" :visible.sync="formVisible" width="800px" :close-on-click-modal="false">
      <el-form ref="dataForm" :rules="formRules" :model="form" label-position="right" size="small" label-width="90px">
        <el-form-item label="预约时间:" prop="value1" class="" :rules="[
                      { required: true, message: '请选择预约日期', trigger: 'change' }
                    ]">
          <el-date-picker v-model="form.value1" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
            :picker-options="pickerOptions">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="" prop="times" class="time-box" :rules="[
                        { required: true, message: '请选择预约时间段', trigger: 'change' }
                      ]">
          <el-time-picker is-range v-model="form.times" range-separator="至" start-placeholder="开始时间"
             :picker-options="{
                   selectableRange: ['09:30', '18:30']
                 }" end-placeholder="结束时间" placeholder="选择时间范围" value-format="HH:mm"
            format="HH:mm" @change="timeChange">
          </el-time-picker>

        </el-form-item>
        <el-form-item label="备注:" prop="remark" class="width100" v-if="type">
          <el-input type="textarea" :rows="2" placeholder="请输入备注" v-model="form.remark">
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="formVisible = false">
          取消
        </el-button>
        <el-button type="primary" @click="doCreate()" :loading="isLoading">
          确认
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
  import technicianServiceOrderApi from '@/api/technical/technicianServiceOrder'

  function initFormBean() {
    const formBean = {
      remark: null,
      value1: '',
      times: null
    }
    return formBean
  }
  export default {
    data() {
      return {
        form: initFormBean(),
        formVisible: false,
        id: '',
        type: null,
        isLoading:false,
        pickerOptions: {
          disabledDate(time) {
            return time.getTime() < Date.now() - 86400000
          }
        },
        pickerTimeOptions: {
          // :picker-options="{
              start: '08:30',
              step: '00:01',
              end: '18:30'
            // }"
          // 设置了选择时间段这些好像没得用
          // disabledHours: () => {
          //   // 禁用 0-7 点的小时，只能选择 8 点之后的时间
          //   return Array.from({
          //     length: 8
          //   }, (_, i) => i);
          // },
          // 还可以设置分钟和秒的禁用逻辑
          // disabledMinutes: (hour) => {
          //   if (hour === 8) {
          //     // 如果是8点，禁用某些分钟
          //     return [0, 1, 2, 3, 4]; // 禁用 8:00, 8:01, ..., 8:04
          //   }
          //   return [];
          // }
        }
      }

    },
    methods: {
      disabledDate(time) {
        return time.getTime() < Date.now() - 8.64e7;
      },
      timeChange(e) {
        console.log('e: ', e);
        if (e[0] == e[1]) {
          this.form.times = null
          this.$message.warning('结束时间必须晚于开始时间')
        }
      },
      resetForm() {
        this.form = initFormBean()
      },
      handleUpdate(data) {
        this.id = data.row.id
        this.type = data.type * 1
        console.log('data: ', data);
        this.resetForm()
        this.formVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
          // this.getConfig()
        })
      },
      doCreate() {
        this.$refs["dataForm"].validate((valid) => {
          if (valid) {
            this.isLoading = true
            // console.log('this.times: ', this.form);
            let params = {
              id: this.id,
              startTime: this.form.value1 + ' ' + this.form.times[0] + ':00',
              endTime: this.form.value1 + ' ' + this.form.times[1] + ':00'
            }
            if (this.form.remark) {
              params.remark = this.form.remark
            }
            technicianServiceOrderApi.updateServiceTime(params).then((data) => {
              this.$message.success('操作成功')
              this.formVisible = false;
              this.$emit('created')
              this.isLoading=false
            }).catch(res=>{
                this.isLoading=false
              });
          }
        });
      },
    }
  }
</script>

<style lang="scss" scoped>
  .el-form-item--small.el-form-item {
    width: 48%;
    display: inline-block;
    vertical-align: top;
  }

  .time-box {
    ::v-deep .el-form-item__content {
      margin-left: 0 !important;
    }
  }

  .el-form-item--small.el-form-item.width100 {
    width: 97%;
  }

  ::v-deep .el-date-editor--date {
    width: 100%;
  }

  ::v-deep .el-date-editor--timerange {
    // width: 65%;
  }

  ::v-deep .el-date-editor--datetime {
    // width: 100%;
  }
</style>
